import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const DeleteArticle = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = () => {
    axios
      .get(`${API_URL}/api/posts`)
      .then((response) => {
        setPosts(response.data);
      })
      .catch((error) => {
        console.error("記事の取得に失敗しました", error);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("本当にこの記事を削除しますか？")) {
      axios
        .delete(`${API_URL}/api/posts/${id}`)
        .then(() => {
          setPosts((prev) => prev.filter((post) => post.id !== id));
        })
        .catch((error) => {
          console.error("記事の削除に失敗しました", error);
        });
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">

      <div style={{ paddingLeft: '50px' }}>
        {/* 戻るボタン */}
        < button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-4 text-blue-600 hover:underline"
          style={{ display: "block", marginTop: "10px", marginBottom: "10px" }}
        >
          ← 前に戻る
        </button >
      </div>

      <hr className="border-t border-gray-300 my-4 w-full" />

      <div style={{ paddingLeft: "50px" }}>
        <h1>削除対象の記事一覧</h1>
        <p>タイトルをクリックして削除してください。</p>
        <ul>
          {posts.map((post) => (
            <li
              key={post.id}
              onClick={() => handleDelete(post.id)}
              style={{ cursor: "pointer", color: "black" }}  //, textDecoration: "underline"
            >
              {post.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DeleteArticle;
